"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as t, forwardRef as m } from "react";
import { useSvgIcon as n } from "../useSvgIcon.js";
const i = t(
  m((r, e) => {
    const C = n({
      ...r,
      ref: e
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...C(),
        children: /* @__PURE__ */ o(
          "path",
          {
            d: "M15.797 21.6789L21.315 25.7209C21.583 25.8871 21.8889 25.9828 22.204 25.9989C22.752 25.9989 23.134 25.5818 23.304 24.7918L26.927 7.82284C27.0046 7.5788 27.0269 7.32054 26.9923 7.0668C26.9577 6.81307 26.8671 6.57024 26.7271 6.35586C26.6303 6.23861 26.5077 6.14526 26.3689 6.08316C26.2301 6.02106 26.0789 5.99186 25.927 5.99783C25.7439 6.00013 25.5626 6.034 25.391 6.09787L4.10805 14.2558C3.38605 14.5358 2.978 14.8998 2.99 15.2558C3 15.5558 3.31702 15.8289 3.85902 15.9989L9.30702 17.6878L21.947 9.77988C22.119 9.65967 22.3214 9.59035 22.531 9.57986C22.664 9.57986 22.76 9.62384 22.788 9.69784C22.816 9.77184 22.7641 9.88987 22.6331 10.0039L12.4041 19.1878L12.013 24.7699C12.2271 24.7712 12.4388 24.7234 12.6316 24.6301C12.8244 24.5368 12.9932 24.4006 13.125 24.2318L15.787 21.6839L15.797 21.6789Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
i.displayName = "IconTelegram";
export {
  i as IconTelegram
};
